module.exports = __webpack_public_path__ + "img/cnc-03-building.e9827832.svg";